import { render, staticRenderFns } from "./facebook-page-insight-metrics-modal.vue?vue&type=template&id=e9d52756"
import script from "./facebook-page-insight-metrics-modal.vue?vue&type=script&lang=js"
export * from "./facebook-page-insight-metrics-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports